/* global http formValidation formHelper modal*/
const formContact = {
	el: {
		html: document.documentElement,
		body: document.body,
		contact: document.querySelector('.js-form-contact')
	},
	fxFormEvents(selector) {
		if (!this.el.contact) return

		const form = {
			el: document.querySelector(selector),
			button: document.querySelector(selector).querySelector('.js-submit')
		}

		form.el.addEventListener('submit', e => {
			e.preventDefault()

			const callback = info => {
				if (info.status === 200) {
					formHelper.fxShowMessage(form, form.el.dataset.msgSuccess)
					if (form.el.classList.contains('form-cookieless')) {
						modal.fxCreateCookie('flyer-downloaded', true, 365)
						const link = document.createElement('a'),
							filename = form.button.dataset.url.split('/').pop()

						link.href = form.button.dataset.url
						link.download = filename
						link.click()
					}
				}
				//handle error
				if (info.response) {
					if (info.response.status === 409)
						formHelper.fxShowMessage(form, form.el.dataset.msgConflict, 409)

					if (info.response.status === 500)
						formHelper.fxShowMessage(form, form.el.dataset.msgServer, 500)
				}
			}

			if (formValidation.fxValidate(e.currentTarget)) {
				http.fxPost(e.currentTarget.getAttribute('action'), formHelper.fxFormToJson(e.currentTarget), callback)
			}
		})
	},
	init() {
		this.fxFormEvents('.js-form-contact')
	}
}

formContact.init()